import { Positioning } from "../../../foundations/positioning.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { styled } from "@mui/material";
import Box from "../../../../node_modules/@mui/system/esm/Box/Box.es.js";
const AcceptedPaymentContainer = styled(Box)({
  ".inner-label": {
    width: "auto",
    padding: `0 ${Spacing["250"]}`,
    position: Positioning.relative,
    background: "inherit"
  }
});
export {
  AcceptedPaymentContainer
};
//# sourceMappingURL=container.es.js.map
